/**
 * @Author: zpc
 * @Description:
 * @DateTime: Created in 2022-05-05 10:19:30
 */

 import ElseSnConfig from '../elseSnConfig';
 import { Toast } from 'src/util/toast';
 import { default as CellOperate } from 'src/components/agGridComponent/cellOperate';
 import { ColDefCustom, default as AgGridVueCustomTsx } from 'src/components/agGridCustom/agGridVueCustomTsx';
 import ElseSnConfigApi, { ElseSnConfigDOI } from '../api/elseSnConfigApi';
 import _ from 'lodash';
 import ListPageService from 'src/types/ListPage';
 import override from 'src/dectorators/override';
 import { QueryFormVOI } from 'src/components/queryForm/queryForm';
 import Input from 'src/types/iview/Input';
 import EnumEntity from 'src/enums/enumEntity';
 import CommonSelect from 'src/components/SelectCustom/commonSelect';
 import EnumUserStatus from 'src/enums/enumUserStatus';
 import EntitySelect from 'src/components/SelectCustom/entitySelect';
 import alertElseSnOperateModal from '../elseSnOperateModal';
 import EnumOperates from 'src/enums/enumOperates';
 import { IconBtnItem } from 'src/components/iconBtnGroup/iconBtnGroup';
 import EnumPermission from 'src/enums/enumPermission';
 import EnumUppercomputerType from 'src/enums/enumUppercomputerType';

 export default class ElseSnConfigService extends ListPageService {
    ctx: ElseSnConfig;

    constructor(ctx: ElseSnConfig) {
        super();
        this.ctx = ctx;
    }

    @override
    createColumns(): ColDefCustom[] {
        let t = this;
        return [
            {
                headerName: 'sn号',
                field: 'sn',
                minWidth: 120,
            },
            {
                headerName: '客户名称',
                field: 'user_name',
                minWidth: 160,
            },
            {
                headerName: '客户手机号',
                field: 'user_phone',
                minWidth: 100,
            },
            {
                headerName: '激活时间',
                field: 'register_time',
                minWidth: 140,
            },
            {
                headerName: '状态',
                field: 'sn_status',
                minWidth: 100,
                maxWidth:100,
                cellRenderer(params) {
                    let data: ElseSnConfigDOI.RowDataI = params.data;
                    return EnumUserStatus.findId(data.sn_status).getName();
                },
            },
            {
                headerName: '权限',
                field: 'lower_computer_permission',
                minWidth: 110,
                maxWidth:110,
                cellRenderer(params) {
                    let data: ElseSnConfigDOI.RowDataI = params.data;
                    return EnumPermission.findId(data.lower_computer_permission).getName();
                },
            },
            {
                headerName: '上位机类型',
                field: 'lower_computer_type',
                minWidth: 130,
                maxWidth:130,
                cellRenderer(params) {
                    let data: ElseSnConfigDOI.RowDataI = params.data;
                    return EnumUppercomputerType.findId(data.lower_computer_type).getName();
                },
            },
            {
                headerName: '操作',
                field: 'operate',
                minWidth: 200,
                maxWidth: 200,
                cellRendererFramework: CellOperate,
                cellRendererFrameworkOpt: [
                    {
                        text: '修改',
                        async click(params) {
                            let data: ElseSnConfigDOI.RowDataI = params.data;
                            let res = await alertElseSnOperateModal(EnumOperates.Update.getName(), data.id);
                            if (res) {
                                t.searchTable();
                            }
                        },
                    },
                    {
                        text: '删除',
                        async click(params) {
                            let res = await Toast.confirm();
                            if (!res) {
                                return;
                            }
                            let data: ElseSnConfigDOI.RowDataI = params.data;
                            await t.delete([data.id]);
                        },
                    },
                    {
                        text: '激活',
                        disabled(params) {
                            let data: ElseSnConfigDOI.RowDataI = params.data;
                            return data.sn_status == 0;
                        },
                        async click(params) {
                            let res = await Toast.confirm("激活","请确认是否激活");
                            if (!res) {
                                return;
                            }
                            let data: ElseSnConfigDOI.RowDataI = params.data;
                            await t.onSn([data.id]);
                        },
                    },
                    {
                        text: '禁用',
                        disabled(params) {
                            let data: ElseSnConfigDOI.RowDataI = params.data;
                            return data.sn_status == 1;
                        },
                        async click(params) {
                            let res = await Toast.confirm("禁用", "请确认是否禁用");
                            if (!res) {
                                return;
                            }
                            let data: ElseSnConfigDOI.RowDataI = params.data;
                            await t.offSn([data.id]);
                        },
                    },
                ],
            },
        ];
    }


    @override
    creatQueryForm(): QueryFormVOI.DateItemType[] {
        return [
            {
                component: Input,
                label: 'sn',
                field: 'sn',
                labelWidth: 20,
                props: { value: '', placeholder: 'sn号' },
            },
            {
                component: Input,
                label: '客户名称',
                field: 'user_name',
                labelWidth: 70,
                props: { value: '', placeholder: '客户名称' },
            },
            {
                component: CommonSelect,
                label: '上位机类型',
                field: 'lower_computer_type',
                labelWidth: 90,
                width:260,
                props: { value: null, dataSource: EnumUppercomputerType.getList() },
            }
        ];
    }

    async delete(ids: number[]) {
        let { code } = await ElseSnConfigApi.delete(ids[0]);
        if (code === 0) {
            Toast.success('删除成功');
            this.searchTable();
        }
    }

    async onSn(ids: number[]) {
        let { code } = await ElseSnConfigApi.onSn(ids[0]);
        if (code === 0) {
            Toast.success('激活成功');
            this.searchTable();
        }
    }

    async offSn(ids: number[]) {
        let { code } = await ElseSnConfigApi.offSn(ids[0]);
        if (code === 0) {
            Toast.success('禁用成功');
            this.searchTable();
        }
    }

    @override
    initSearchParams(): void {
        this.ctx.searchParams = this.ctx.queryForm.getQueryObj<ElseSnConfigDOI.QueryRowDataParamsI>();
        this.ctx.currentPage = 1;
    }

    @override
    async searchTable() {
        let ctx = this.ctx;
        let ag = this.ctx.$refs.ag as AgGridVueCustomTsx;
        ag.showLoading();
        let { code, data } = await ElseSnConfigApi.searchList({
            ...ctx.searchParams,
            page_size: ctx.pageSize,
            page_index: ctx.currentPage,
        });
        ag.hideLoading();

        if (code === 0) {
            ctx.rowData = data.data_info || [];
            ctx.total = data.page_count;
        }
    }
 }